export interface TenantConfig {
  tenantName: string;
  sheetName?: string; // set from Auth0 user id after login
  googleApiKey: string;
  googleClientId?: string;
  authProvider?: 'google' | 'none' | 'auth0';
  auth0Domain?: string;
  auth0ClientId?: string;
  customApiKey: string;
  categories: {
    income: string[];
    expense: string[];
  };
  serverApiUrl: string;
  // Thêm các config khác
  displayName: string;
  appVersion: string;
  appName: string;
  theme?: {
    primaryColor: string;
    secondaryColor: string;
  };
  features?: {
    enableExport: boolean;
    enableImport: boolean;
    enableAnalytics: boolean;
  };
  // Optional configurable app icon URL (fallback when user picture not used)
  appIconUrl?: string;
}

// Không cần defaultConfig nữa - sẽ lấy từ window.SAAS_CONFIG trong config.js

// Hàm load config từ window.SAAS_CONFIG
function loadConfigFromWindow(): TenantConfig {
  if (typeof window !== 'undefined' && (window as any).SAAS_CONFIG) {
    return (window as any).SAAS_CONFIG as TenantConfig;
  }
  
  // Throw error nếu không có config - buộc phải có config.js
  throw new Error('SAAS_CONFIG not found in window. Please ensure config.js is loaded.');
}

// Hàm lấy config theo sheetName
export function getTenantConfig(sheetName: string): TenantConfig {
  const config = loadConfigFromWindow();
  return {
    ...config,
    sheetName,
    tenantName: sheetName, // Có thể cập nhật từ UI nếu cần
  };
}

// Hàm lấy config hiện tại
export function getCurrentConfig(): TenantConfig {
  return loadConfigFromWindow();
}
